export default __webpack_public_path__ + "static/B0073-424b85f4fa395d614d2f4b0de4ead11b.png";